var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mheader",style:({
    backgroundColor: _vm.user.event_color,
    backgroundImage: 'url(' + _vm.user.event_logo + ')',
  }),on:{"click":_vm.handleClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }